import { create } from 'zustand';
import { shallow } from 'zustand/shallow';

export enum HomeHeroAuthenticationStep {
  Login,
  Registration,
  TwoFactorAuthentication,
}

export enum LoginFlowVariant {
  Email = 'EMAIL',
  Mobile = 'MOBILE',
}

export interface AuthenticationStore {
  homeHeroAuthenticationStep: HomeHeroAuthenticationStep;
  loginFlowVariant: LoginFlowVariant;
  username?: string;
  password?: string;
  postRegisterData?: { userId: number; btag: string };
}

type AuthenticationActions = {
  setHomeHeroAuthenticationStep: (homeHeroAuthenticationStep: HomeHeroAuthenticationStep) => void;
  setLoginFlowVariant: (loginFlowVariant: LoginFlowVariant) => void;
  setAuthenticationCredentials: (username: string, password: string) => void;
  setPostRegisterData: (userId: number, btag: string) => void;
  reset: () => void;
};

type State = AuthenticationStore;

const initialState: State = {
  homeHeroAuthenticationStep: HomeHeroAuthenticationStep.Registration,
  loginFlowVariant: LoginFlowVariant.Email,
  username: undefined,
  password: undefined,
  postRegisterData: undefined,
};

export const useHomeHeroAuthenticationStep = create<{ data: State } & AuthenticationActions>(
  set => ({
    data: initialState,
    setHomeHeroAuthenticationStep: (homeHeroAuthenticationStep: HomeHeroAuthenticationStep) =>
      set(state => ({ data: { ...state.data, homeHeroAuthenticationStep } })),
    setLoginFlowVariant: (loginFlowVariant: LoginFlowVariant) =>
      set(state => ({ data: { ...state.data, loginFlowVariant } })),
    setAuthenticationCredentials: (username, password) =>
      set(state => ({
        data: {
          ...state.data,
          username,
          password,
        },
      })),
    setPostRegisterData: (userId: number, btag: string) =>
      set(state => ({
        data: {
          ...state.data,
          postRegisterData: { userId, btag },
        },
      })),
    reset: () => set({ data: initialState }),
  }),
);

export const useHomeHeroAuthenticationStepData = () => {
  return useHomeHeroAuthenticationStep(state => state.data, shallow);
};

export const useHomeHeroAuthenticationStepActions = () => {
  return useHomeHeroAuthenticationStep(
    state => ({
      setHomeHeroAuthenticationStep: state.setHomeHeroAuthenticationStep,
      setLoginFlowVariant: state.setLoginFlowVariant,
      setAuthenticationCredentials: state.setAuthenticationCredentials,
      setPostRegisterData: state.setPostRegisterData,
      reset: state.reset,
    }),
    shallow,
  );
};
